import React from "react";

// Lightweight, safe-ish markdown renderer for AI teacher responses.
export default function AiText({ text }) {
  if (!text) return null;
  const lines = text.split("\n");
  const blocks = [];
  let list = [];

  const flush = () => {
    if (list.length) {
      blocks.push(
        <ul key={`ul-${blocks.length}`}>
          {list.map((it, i) => <li key={i} dangerouslySetInnerHTML={{ __html: inline(it) }} />)}
        </ul>
      );
      list = [];
    }
  };

  function inline(s) {
    return s
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
      .replace(/\*(.+?)\*/g, "<em>$1</em>");
  }

  lines.forEach((raw, idx) => {
    const line = raw.trimEnd();
    if (/^#{1,3}\s/.test(line)) {
      flush();
      const t = line.replace(/^#{1,3}\s/, "");
      blocks.push(<h3 key={idx} dangerouslySetInnerHTML={{ __html: inline(t) }} />);
    } else if (/^[-*•]\s/.test(line)) {
      list.push(line.replace(/^[-*•]\s/, ""));
    } else if (line.trim() === "") {
      flush();
    } else {
      flush();
      blocks.push(<p key={idx} dangerouslySetInnerHTML={{ __html: inline(line) }} />);
    }
  });
  flush();

  return <div className="prose-chat text-slate-700">{blocks}</div>;
}
